module.exports = __webpack_public_path__ + "static/media/personalDev.d3410d1d.jpg";